import Popover from "@/v2-ui/popover"
import {
  TooltipButton,
  type TooltipButtonProps,
} from "@/v2-backoffice-client/components/button"
import { useSelectorContext } from "@/v2-backoffice-client/components/selector/selector.context"

// TooltipButton rather than Button so a selector sitting in a toolbar can
// explain itself like every other button there. It stays silent until a
// caller passes `content` (or is icon-only with a `label`).
export type SelectorTriggerProps = Omit<TooltipButtonProps, "ref">

function SelectorTrigger(props: SelectorTriggerProps) {
  const { variant = "outline", size = "sm", ...buttonProps } = props
  const { isLoading, triggerRef } = useSelectorContext()
  return (
    <Popover.Trigger asChild>
      <TooltipButton
        // Measured by Selector when the content opens, to place it.
        ref={triggerRef}
        variant={variant}
        size={size}
        isLoading={isLoading}
        {...buttonProps}
      />
    </Popover.Trigger>
  )
}

export default SelectorTrigger
